import {useMatches} from 'react-router'
import {Link} from '@freckle/educator-materials/ts/components/link'
import {Text} from '@freckle/educator-materials/ts/components/typography'
import {useSafeTranslation} from '@freckle/educator-materials/ts/helpers/translate'
import type {SidebarIdT} from './../logic'
import {
  getDataTestFromTabId,
  getSidebarLinkTranslateKeyFromTabId,
  getTabIdForRoute
} from './../logic'
import {linkWrapperStyle, activeStyle, primaryLinkStyle} from './sidebar-link.module.scss'

type Props = {
  tabId: SidebarIdT
  href: string
}

export function SidebarLink(props: Props) {
  const {t} = useSafeTranslation()
  const {tabId, href} = props

  const routeMatch = useMatches()

  const currentTabId = getTabIdForRoute(routeMatch[0]!.pathname)
  const isActive = currentTabId === tabId

  return (
    <li className={`${linkWrapperStyle} ${isActive ? activeStyle : ''}`}>
      <Link
        className={primaryLinkStyle}
        href={href}
        dataTest={getDataTestFromTabId(tabId)}
        reactRouter
      >
        <Text style="subtitle-2" htmlElement="span">
          {t(getSidebarLinkTranslateKeyFromTabId(tabId))}
        </Text>
      </Link>
    </li>
  )
}
